import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[wizardTitle]'
})
export class WizardTitle {
  template = inject<TemplateRef<any>>(TemplateRef);
}
